(function($) {
    
    //If on mobile
    if(window.matchMedia("(max-width: 576px)").matches && 1!==1) {
        
        
        //Set positions and height
        var headerHeight = $(".sticky-header").outerHeight();
        var section = $(".pre-owned-yachts");
        var sectionHeight = section.outerHeight();
        
        var leftWhiteSpace = $(".white-space-left");
        var rightWhiteSpace = $(".white-space-right");
        
        var triggerPoint = 0;
        var delta = 0;
        
        var animate = true;
        
        $(window).on('load', function() {
            $(".animation-fade-in").css('opacity', 0);
            
            //Set waypoint
            var waypoint = $(".pre-owned-yachts").waypoint({
                handler: function(direction) {
                    if(direction == 'down') {
                        $('.pre-owned-yachts__animation-container').addClass('animation-stick');
                    }
                    else {
                        $('.pre-owned-yachts__animation-container').removeClass('animation-stick');
                    }
                },
                offset: headerHeight
            });
            
            //Save trigger point
            triggerPoint = waypoint[0].triggerPoint;
            
            
            $(window).on('scroll', function() {    
                //Delta = length past way point
                delta = $(window).scrollTop() - triggerPoint;
                
                //Calculate Offsets
                var whiteSpaceOffset = delta * 0.1;
                var opacityOffset =  ((whiteSpaceOffset - leftWhiteSpace.outerWidth()) * 0.07);
                
                if(animate) { 
                    $('.pre-owned-yachts__animation-container').css('top', headerHeight);
                    
                    //Extend Height
                    if(delta >= 0) {
                        section.css('height', (sectionHeight + delta));
                    }
                    else {
                        section.css('height', sectionHeight);
                    }
                    
                    //Animate sides
                    if(whiteSpaceOffset >= 0) {
                        leftWhiteSpace.css('transform', `TranslateX(-${whiteSpaceOffset}px)`);
                        rightWhiteSpace.css('transform', `TranslateX(${whiteSpaceOffset}px)`);
                    }
                    else {
                        leftWhiteSpace.css('transform', `TranslateX(0)`);
                        rightWhiteSpace.css('transform', `TranslateX(0)`);
                    }
                    
                    //Animate Opacity
                    if(opacityOffset >= 0) {
                        $(".animation-fade-in").css('opacity', opacityOffset);
                    }
                    else {
                        $(".animation-fade-in").css('opacity', 0);
                    }
                }
                
                if(opacityOffset >= 1) {
                    animate = false;
                    $('.pre-owned-yachts__animation-container').addClass('animation-secure').css('top', '');
                }
                else {
                    animate = true;
                    $('.pre-owned-yachts__animation-container').removeClass('animation-secure');
                }
            })
        })
        
    }
    
})(jQuery);


// var elm = document.querySelector('b');

// var onScroll = (function(){
//   var startPos;

//   function run(){
//     var fromTop = window.pageYOffset, 
//         rect = elm.getBoundingClientRect(),
//         scrollDelta;

//     // check if element is in viewport
//     if( (rect.top - window.innerHeight) <= 0 && rect.bottom > 0 )
//        startPos = startPos === undefined ? fromTop : startPos;
//     else{
//       startPos = 0;
//       return;
//     }

//     scrollDelta = (fromTop - startPos) * 1; // "speed" per scrolled frame
//     elm.style.transform = `translateX(${scrollDelta}px) rotate(${scrollDelta}deg)`;

//     console.clear();
//     console.log(scrollDelta);
//   }

//   run();

//   return run;
// })()

// window.addEventListener('scroll', onScroll);